var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMenuDashboard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.49 7.80863V7.81V16.19C21.49 17.9106 20.9791 19.2238 20.0964 20.1064C19.2138 20.9891 17.9006 21.5 16.18 21.5H7.81C6.08945 21.5 4.77634 20.9891 3.89377 20.1054C3.01114 19.2217 2.5 17.9059 2.5 16.18V7.81C2.5 6.08944 3.01093 4.77618 3.89355 3.89355C4.77618 3.01093 6.08944 2.5 7.81 2.5H16.19C17.9107 2.5 19.2237 3.01097 20.105 3.89333C20.9861 4.77559 21.4947 6.08838 21.49 7.80863Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1789 14.6868L7.17895 14.6868L7.17192 14.6815C7.06707 14.602 7.0419 14.4476 7.12764 14.3331L9.50472 11.2469C9.71621 10.9779 10.0087 10.8087 10.3433 10.766L10.3447 10.7658C10.6697 10.7234 11.0054 10.8151 11.2712 11.0233C11.2713 11.0234 11.2714 11.0234 11.2715 11.0235L13.0945 12.458C13.2926 12.6223 13.5064 12.6381 13.6546 12.6176C13.8355 12.602 14.027 12.5084 14.1671 12.3239L16.4752 9.34633L16.4752 9.34635L16.4785 9.34194C16.5598 9.23469 16.7168 9.2185 16.8147 9.29806L16.8213 9.30342L16.8281 9.30855C16.9325 9.38771 16.956 9.53798 16.8672 9.65057L16.8648 9.65368L14.5565 12.6316C14.5562 12.6319 14.556 12.6322 14.5557 12.6325C14.3438 12.9024 14.054 13.068 13.7271 13.1028L13.7271 13.1027L13.7167 13.104C13.3814 13.1468 13.055 13.0553 12.7888 12.8468C12.7887 12.8467 12.7886 12.8466 12.7884 12.8465L10.9653 11.4119C10.7743 11.2538 10.5566 11.2296 10.3997 11.2529C10.2202 11.27 10.031 11.3638 9.89235 11.5469L7.51387 14.6349L7.50167 14.6507L7.49077 14.6675C7.46644 14.7049 7.41699 14.74 7.32999 14.74C7.27746 14.74 7.22729 14.7249 7.1789 14.6868Z",
    fill: "white",
    stroke: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMenuDashboard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-menu-dashboard.188c72591fad9f2a0e65f1d167421573.svg";